<template>
  <bc-select
    v-model="colorId"
    :options="colors"
    :default-placeholder="defaultPlaceholder"
  >
    <template #noresults>
      <li class="dropdown-item px-4 py-2 text-red-500">Barva nenalezena</li>
    </template>
    <template #option="slotProps">
      <li
        role="option"
        class="
          cursor-default
          select-none
          relative
          py-2
          pl-4
          pr-4
          truncate
          d-flex
        "
        :class="{
          'text-white bg-bc-blue': slotProps.highlighted,
          'text-gray-800': !slotProps.highlighted
        }"
        @mouseenter="slotProps.handleMouseEnter(slotProps.option)"
        @click.stop="slotProps.selectOption(slotProps.option)"
      >
        <span>
          <span class="Pictogram mr-2" :style="bgColor(slotProps.option)"
            >&nbsp;</span
          >
        </span>
        {{ slotProps.option.label }}
      </li>
    </template>
  </bc-select>
</template>
<script>
import findIndex from 'lodash/findIndex'

export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: String,
    id: String,
    colors: Array
  },
  computed: {
    colorId: {
      get() {
        return this.modelValue
      },
      set(newVal) {
        this.$emit('update:modelValue', newVal)
      }
    },
    defaultPlaceholder() {
      const index = findIndex(this.$controls[this.id].items, ['id', ''])
      return this.$controls[this.id].items[index].label
    }
  },
  methods: {
    bgColor(option) {
      return {
        'background-color':
          'rgb(' + option.r + ', ' + option.g + ', ' + option.b + ')'
      }
    }
  }
}
</script>
